import { tx } from "@/i18n/tx";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home, BookOpen, Compass, Sparkles, User } from "lucide-react";

const items = [
  { to: "/app", key: "nav.home", label: tx("Home"), icon: Home, testid: "nav-home", end: true },
  { to: "/app/diario", key: "nav.diario", label: tx("Diario"), icon: BookOpen, testid: "nav-diario" },
  { to: "/app/percorso", key: "nav.percorso", label: tx("Percorso"), icon: Compass, testid: "nav-percorso" },
  { to: "/app/simboli", key: "nav.simboli", label: tx("Simboli"), icon: Sparkles, testid: "nav-simboli" },
  { to: "/app/profilo", key: "nav.profilo", label: tx("Profilo"), icon: User, testid: "nav-profilo" },
];

export function BottomNav() {
  const { t } = useTranslation();
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-40 px-4 pt-2 pb-[calc(0.75rem+env(safe-area-inset-bottom))]"
    >
      <div className="anima-card rounded-full flex items-center justify-around px-2 py-2 shadow-[0_8px_30px_rgba(122,115,112,0.12)]">
        {items.map(({ to, key, label, icon: Icon, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-2.5 py-1.5 rounded-full transition-colors duration-300 ${
                isActive ? "text-anima-ink" : "text-anima-muted"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className={`p-1.5 rounded-full transition-colors duration-300 ${isActive ? "bg-anima-sage/30" : ""}`}>
                  <Icon size={19} strokeWidth={1.6} />
                </span>
                <span className="text-[10px] tracking-wide">{t(key, label)}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
